import React from "react"

import { Picture } from "@hurleymc/components"
import { defaultProfileImageSrc } from "./default-profile-image-src"

export const DefaultProfileImage = () => (
  <Picture alt="Default Profile Image" src={defaultProfileImageSrc} />
)
